export const ADMIN_PROPERTIES_PAGE_SIZE = 25;

function clampPageSize(pageSize) {
  const size = Number(pageSize);
  return Number.isFinite(size) && size > 0 ? Math.floor(size) : ADMIN_PROPERTIES_PAGE_SIZE;
}

/**
 * Browse request for listAdminProperties.
 * @param {{ pageSize?: number, pageToken?: string | null }} [params]
 */
export function buildPropertiesBrowseRequest({
  pageSize = ADMIN_PROPERTIES_PAGE_SIZE,
  pageToken,
} = {}) {
  const request = {
    mode: 'browse',
    pageSize: clampPageSize(pageSize),
  };
  if (pageToken) request.pageToken = String(pageToken);
  return request;
}

/**
 * Exact propertyId lookup. Never paginated — do not send pageToken.
 * pageSize is omitted so the backend contract stays non-paginated.
 * @param {string} propertyId
 */
export function buildPropertyIdLookupRequest(propertyId) {
  return {
    mode: 'lookup',
    propertyId: String(propertyId || '').trim(),
  };
}

/**
 * Owner UID lookup. Pagination uses the same pageToken as browse, in a separate stack.
 * @param {{ uid: string, pageSize?: number, pageToken?: string | null }} params
 */
export function buildOwnerUidLookupRequest({
  uid,
  pageSize = ADMIN_PROPERTIES_PAGE_SIZE,
  pageToken,
} = {}) {
  const request = {
    mode: 'lookup',
    uid: String(uid || '').trim(),
    pageSize: clampPageSize(pageSize),
  };
  if (pageToken) request.pageToken = String(pageToken);
  return request;
}

/**
 * Owner email lookup. Exact email only. Pagination is owner-lookup pageToken.
 * @param {{ email: string, pageSize?: number, pageToken?: string | null }} params
 */
export function buildOwnerEmailLookupRequest({
  email,
  pageSize = ADMIN_PROPERTIES_PAGE_SIZE,
  pageToken,
} = {}) {
  const request = {
    mode: 'lookup',
    email: String(email || '').trim(),
    pageSize: clampPageSize(pageSize),
  };
  if (pageToken) request.pageToken = String(pageToken);
  return request;
}
